import React, { useCallback, useEffect,useState } from "react";
import { Col, Typography, Row, Card, Divider, Button, Flex, Spin  } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/examination/actions";
import config from "../Services/apiEndPoints";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function ExamAnswerKey() {
  const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
  const studentId = localStorage.getItem("Student_Id");
  const exam_id = localStorage.getItem("examId");
  const question_paper_id = localStorage.getItem("question_paper_id");
  const dispatch = useDispatch();
  const { answersheet, isFetching } = useSelector((state) => state.Examination);

  const getAnswersheet = useCallback(() => {
    dispatch(actions.resetActionType1());
    dispatch(
      actions.getanswersheet(
        `${config.getAnswersheet}?student_id=${studentId}&exam_id=${exam_id}&question_paper_id=${question_paper_id}`
      )
    );
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getAnswersheet();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(`/dashboard/examResults/id=${studentId}`)}
        style={{ width: "50px", marginTop: "15px", marginLeft: "8px" }}
      ></Button>
      <div>
        {loading ? (
          <Flex
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </Flex>
        ) : (
          <Card
            style={{
              maxWidth: "900px",
              margin: "30px auto",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              background: "#f9fafb",
            }}
          >
            <Typography.Title
              level={3}
              style={{
                textAlign: "center",
                color: "#1890ff",
                fontWeight: 700,
                marginTop: "-20px",
                marginBottom: "15px",
              }}
            >
              Answer Sheet
            </Typography.Title>

            <Row gutter={[16, 16]}>
              {answersheet?.map((eachQus, index) => (
                <Col span={24} key={index}>
                  <Card
                    hoverable
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      padding: "20px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.transform = "scale(1.03)")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.transform = "scale(1)")
                    }
                  >
                    <Title
                      level={5}
                      style={{ marginBottom: "12px", color: "#333" }}
                    >
                      <span
                        style={{
                          backgroundColor: "#1890ff",
                          color: "white",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          fontSize: "14px",
                        }}
                      >
                        Q{index + 1}
                      </span>
                      <Text> {eachQus?.question}</Text>
                    </Title>
                    <Divider
                      style={{ margin: "10px 0", borderColor: "#f0f0f0" }}
                    />

                    <Row justify="space-between" align="middle">
                      <Col xs={24} sm={8} style={{ textAlign: "right" }}>
                        <Text
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#52c41a",
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <CheckCircleOutlined
                            style={{
                              marginRight: "8px",
                              fontSize: "18px",
                              verticalAlign: "middle",
                            }}
                          />
                          <span style={{ fontSize: "16px" }}>Ans: </span>
                          <span style={{ fontSize: "18px", color: "#52c41a" }}>
                            {eachQus.answer}
                          </span>
                        </Text>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>
        )}
      </div>
    </>
  );
}
